import { isNullOrUndefined } from './is-null-or-undefined';

export const sanitizeOrderQueryParams = (
  orderId: number,
  orderType: string = null,
  businessLine: string = null,
  country: string = null,
) => {
  return {
    orderId: !isNullOrUndefined(orderId) ? orderId : null,
    orderType: orderType,
    businessLine: !isNullOrUndefined(businessLine) ? businessLine : null,
    country: !isNullOrUndefined(country) ? country : null,
  };
};

export const createOrderUrl = (
  orderId: number,
  orderType: string = null,
  businessLine: string = null,
  country: string = null,
): string => {
  let url = '/ordersnproduct/app/order-detail?';
  const params = sanitizeOrderQueryParams(orderId, orderType, businessLine, country);
  let first = true;
  Object.keys(params).map(key => {
    const value = params[key];
    if (!value) {
      return;
    }
    if (first) {
      url = url + `${key}=${value}`;
      first = false;
      return;
    }
    url = url + `&${key}=${value}`;
  });
  return url;
};
